var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalloonRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.592,
    height: 126.755,
    viewBox: "0 0 50.592 126.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M50.592,25.3c0,13.969-11.327,36.266-25.3,36.266S0,39.265,0,25.3a25.3,25.3,0,1,1,50.592,0Z",
    fill: "#ff6584",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.71,117.29c-3.2,1.1-3.941,5.432-2.844,8.611s6.534,12,6.534,25.818c0,12.813-11.045,23.523-15.71,29.231",
    transform: "translate(-12.476 -54.828)",
    fill: "none",
    stroke: "#2f2e41",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8,117.759a4.191,4.191,0,0,0-4.878,0V115H47.8Z",
    transform: "translate(-20.063 -53.757)",
    fill: "#ff6584"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43,115.41a5.384,5.384,0,0,0,4.883,0",
    transform: "translate(-20.101 -53.949)",
    fill: "none",
    stroke: "#2f2e41",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.575,28.271c2.945,0,5.325-2.865,5.325-6.391s-2.386-6.391-5.325-6.391-5.325,2.865-5.325,6.391S59.625,28.271,62.575,28.271Z",
    transform: "translate(-26.762 -7.241)",
    fill: "#fff",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonRed);
export default __webpack_public_path__ + "static/media/balloon_red.29e8f91958dfa477cb777da58cd2df11.svg";
export { ForwardRef as ReactComponent };